import React from 'react';
import { Button } from 'components/mui';
import { string, func, bool } from 'prop-types';

/**
 * @component FolderPermissionsButton
 * 
 * Reusable button component for opening folder permissions modal.
 * Used in UserInfoForm for both simple and full UIs.
 * 
 * @param {Object} props
 * @param {function} props.onClick - Callback when button is clicked
 * @param {boolean} [props.disabled=false] - Whether button is disabled
 * @param {string} [props.variant="outlined"] - Material UI button variant
 * @param {boolean} [props.fullWidth=true] - Whether button takes full width
 * @param {string} [props.size="medium"] - Button size (small, medium, large)
 * @returns {JSX.Element}
 * 
 */
function FolderPermissionsButton({ 
    onClick, 
    disabled = false,
    variant = "outlined",
    fullWidth = true,
    size = "medium"
}) {
    return (
        <Button
            variant={variant}
            fullWidth={fullWidth}
            size={size}
            onClick={onClick}
            disabled={disabled}
            sx={{ 
                py: 1.5,
                borderStyle: 'solid',
                fontSize: '1rem',
                textTransform: 'none',
                borderColor: 'rgba(25, 118, 210, 0.3)',
                '&:hover': {
                    borderColor: 'primary.main',
                },
            }}
        >
            CANshare Folder Permissions
        </Button>
    );
}

FolderPermissionsButton.propTypes = {
    onClick: func.isRequired,
    disabled: bool,
    variant: string,
    fullWidth: bool,
    size: string
};

export default FolderPermissionsButton;
